"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _KeyStore = require("crm_data/store/KeyStore");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _ObjectAssociationTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectAssociationTypes"));

var _makeKey = function _makeKey(subjectId, objectType) {
  return (0, _immutable.Map)({
    subjectId: subjectId,
    objectType: objectType
  });
};

var emptyAssociationMap = (0, _immutable.Map)({
  ownerIds: (0, _immutable.Set)(),
  contactIds: (0, _immutable.Set)(),
  companyIds: (0, _immutable.Set)(),
  dealIds: (0, _immutable.Set)(),
  ticketIds: (0, _immutable.Set)()
});

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: 'ENGAGEMENT_ASSOCIATIONS',
  idIsValid: function idIsValid(key) {
    return typeof key.get('subjectId') === 'number' && typeof key.get('objectType') === 'string';
  }
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_UPDATE, function (state, _ref) {
  var subjectId = _ref.subjectId,
      objectType = _ref.objectType,
      associatedObjectType = _ref.associatedObjectType,
      associatedIds = _ref.associatedIds;

  var key = _makeKey(subjectId, objectType);

  var associationsMap = state.get(key, emptyAssociationMap);
  associationsMap = associationsMap.update(_ObjectAssociationTypes.default[associatedObjectType], function (ids) {
    return ids.concat(associatedIds);
  });
  return state.set(key, associationsMap);
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_MERGE_AND_UPDATE, function (state, _ref2) {
  var subjectId = _ref2.subjectId,
      objectType = _ref2.objectType,
      associationsMapToMerge = _ref2.associationsMapToMerge,
      currentAssociations = _ref2.currentAssociations;

  var key = _makeKey(subjectId, objectType);

  var associationsMap = state.get(key, emptyAssociationMap);
  associationsMapToMerge.forEach(function (idsToAdd, objectTypeKey) {
    associationsMap = associationsMap.update(objectTypeKey, function () {
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
      return ids.concat(idsToAdd);
    });
  });
  currentAssociations.forEach(function (idsToAdd, objectTypeKey) {
    associationsMap = associationsMap.update(objectTypeKey, function () {
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
      return ids.concat(idsToAdd);
    });
  });
  return state.set(key, associationsMap);
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_MERGE, function (state, _ref3) {
  var subjectId = _ref3.subjectId,
      objectType = _ref3.objectType,
      associationsMapToMerge = _ref3.associationsMapToMerge,
      currentAssociations = _ref3.currentAssociations;

  var key = _makeKey(subjectId, objectType);

  var associationsMap = currentAssociations.mergeDeep(associationsMapToMerge);
  return state.set(key, associationsMap);
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_DELETE, function (state, _ref4) {
  var subjectId = _ref4.subjectId,
      objectType = _ref4.objectType,
      associatedObjectType = _ref4.associatedObjectType,
      associatedId = _ref4.associatedId;

  var key = _makeKey(subjectId, objectType);

  return state.updateIn([key, _ObjectAssociationTypes.default[associatedObjectType]], function (ids) {
    if (!ids) {
      return ids;
    }

    return ids.delete(associatedId);
  });
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_REFRESH, function (state, _ref5) {
  var subjectId = _ref5.subjectId,
      objectType = _ref5.objectType;

  var key = _makeKey(subjectId, objectType);

  return state.delete(key);
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_RESTORE_CALL_ASSOCIATIONS, function (state, _ref6) {
  var objectType = _ref6.objectType,
      subjectId = _ref6.subjectId,
      associations = _ref6.associations;

  var key = _makeKey(subjectId, objectType);

  return state.set(key, associations);
}).register();

exports.default = _default;
module.exports = exports.default;